import { render, staticRenderFns } from "./FlagForm.vue?vue&type=template&id=076b98c6&scoped=true&"
import script from "./FlagForm.vue?vue&type=script&lang=js&"
export * from "./FlagForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "076b98c6",
  null
  
)

export default component.exports